import React from "react";
import AddSubHeadForm from "../../components/BudgetAllocation/Schemes/AddSubheadForm";

const AddNewSubhead = () => {
    return (
        <>
            <AddSubHeadForm />
        </>
    );
};

export default AddNewSubhead;